<template>
<div class="header">
  <h1 class="title">{{ blogname }}</h1>
  <p>{{ blogdescription }}</p>
  <nav class="nav">
    <ul>
      <li >
        <RouterLink :to="{ name: 'home'}">首页</RouterLink>
      </li>
      <li v-for="item in nav_terms" :key="item.term_id">
        <RouterLink :to="{ name: 'list', params: { id: item.term_id }}">{{ item.name }}</RouterLink>
      </li>
      <li >
        <RouterLink :to="{ name: 'xiaohua'}">笑话大全</RouterLink>
      </li>
    </ul>
  </nav>
</div>
  <div class="body">
    <router-view></router-view>
  </div>

  <div>
    <BaseFooter :icp="icp" />
  </div>
  <el-backtop :right="100" :bottom="100" />
</template>

<script>
import { inject } from 'vue';
import { ref } from 'vue'
import axios from 'axios';

import FooterComponent from './views/FooterComponent.vue';
export default {
  name: 'App',
  methods:{
    handler()
    {


    }
  },
  setup(){
    var api_url=inject('api_url')
    const blogname=ref();
    const blogdescription=ref();
    const icp=ref();
    const nav_terms=ref([]);
    axios.get(api_url+"index")
        .then(response => {
          if(response.data.status===1)
          {
            blogname.value=response.data.data.blogname;
            blogdescription.value=response.data.data.blogdescription;
            icp.value=response.data.data.icp;
            nav_terms.value=response.data.data.nav;
            document.title=response.data.data.blogname;
          }
        })
        .catch(error => {
          console.error('There was an error!', error);
        });
    return {
      blogname,
      blogdescription,
      icp,
      nav_terms,
    }
  },
  components: {
    BaseFooter: FooterComponent,
  }
}
</script>

